import React from 'react';
import OrderAndReview from './OrderAndReview';
import AccountSetting from './AccountSetting';
import '../styles/Profile.css'; 
import Box from '@mui/material/Box';
import Music from './Music';

function Profile() {
  return (
    <div className="profile-page-container">

      {/*  Music Player (Top / Sticky Area) */}
      <div className="profile-page-grid">
        <div className="profile-grid-item">
          <AccountSetting />
        </div>
      <div className="music-wrapper">
        <Music />
      </div>
 </div>
      {/* Main Grid */}
      

        <div className="profile-grid-item">
          <OrderAndReview />
        </div>
      </div>

   
  );
}


export default Profile;